export default __webpack_public_path__ + "static/media/icon-entnahmemenge.8c4bcb69.svg";